<fgb-banner [pageTitle]="'lotto.page.title'"></fgb-banner>
<fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>

<div class="container rewards-list-container">
  <fgb-upgrade-banner></fgb-upgrade-banner>
  <fgbcl-lottos-list-v2 [isList]="true" [defaultSort]="1"> </fgbcl-lottos-list-v2>
</div>
